export const SPEEDS = [0.5, 1, 2] as const;

export type Speed = (typeof SPEEDS)[number];
